const reviewParams = ':eventType/:envId/:id';
export const velocitiesPath = 'velocities';
export const globalFunctionsPath = 'functions';

export enum RuleRoutes {
	RoutingRules = 'routingrules',
	Rules = 'rules',
}

export const RoutePaths = {
	Root: '/',
	Fraud: {
		Root: '/fraud',
	},
	Assessments: {
		Root: '/fraud/assessments',
		RootV2: '/fraud/assessments/:assessmentId',
		Monitoring: '/fraud/assessments/:assessmentId/monitor',
		Rules: '/fraud/assessments/:assessmentId/rules',
		Configuration: '/fraud/assessments/:assessmentId/configuration',
		Setup: '/fraud/assessments/setup',
		EditSchema: '/fraud/assessments/:assessmentId/schemaDetails',
		CreateLabel: '/fraud/assessments/:assessmentId/observations/create/label',
		CreateObservation: '/fraud/assessments/:assessmentId/observations/create',
		EditLabel: '/fraud/assessments/:assessmentId/observations/label',
		EditObservation: '/fraud/assessments/:assessmentId/observations/:observationId',
	},
	Integration: {
		Dashboard: '/integration',
		DeviceFingerprinting: {
			Try: '/devicefingerprinting/try',
		},
	},
	CaseManagement: {
		Root: '/casemanagement',
		QueueDashboard: '/casemanagement/queues',
		Queue: '/queues/:queueId',
		Review: `/queues/:queueId/${reviewParams}`,
		Rules: `/casemanagement/${RuleRoutes.RoutingRules}`,
		Report: `/casemanagement/report`,
	},
	Environments: {
		Manage: '/environments',
	},
	Search: '/search',
	SearchResult: `/search/${reviewParams}`,
	Settings: {
		Root: '/settings',
		Audit: '/settings/audit',
		AuditResult: `/settings/${reviewParams}`,
		AuditResultParams: `/${reviewParams}`,
		Rbac: '/settings/access',
		RbacApps: '/settings/access/apps',
		SubjectRequests: {
			Root: '/settings/subject',
		},
		Tab: {
			Root: '/settings/transactionacceptancebooster',
		},
	},
	Data: {
		Root: '/data',
		Velocities: `/data/${velocitiesPath}`,
		ExternalCalls: '/data/externalcalls',
		ExternalAssessments: '/data/externalassessments',
		Lists: {
			Root: '/data/lists',
			Custom: '/data/lists/custom',
			Support: '/data/lists/support',
		},
		EventTracing: '/data/eventtracing',
		Templates: '/data/templates',
		GlobalFunctions: `/data/${globalFunctionsPath}`,
	},
	AdminSettings: {
		Root: '/adminsettings',
		Search: '/adminsettings/search',
	},
};
